import {
    apiClient as api
} from './APIService'

const authedOptions = {
    headers: { "x-access-token": localStorage.getItem("jwt") },
}

export const getUserCart = () => {
    return api.get('cart', authedOptions)
}

export const addToCart = (price_id, product_id) => {
    return api.post('cart/add', {
        price_id,
        product_id
    }, authedOptions)
}

export const removeFromCart = (price_id) => {
    return api.delete('cart/remove', {
        params: {
            price_id
        }
    })
}